import { render, staticRenderFns } from "./CheckDeposit.vue?vue&type=template&id=2c0fc2de&"
import script from "./CheckDeposit.vue?vue&type=script&lang=js&"
export * from "./CheckDeposit.vue?vue&type=script&lang=js&"
import style0 from "./CheckDeposit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports